/* eslint-disable no-console */
import {
  IMinUserDetails,
  INovaUserAuthHeaders,
  INovaUserGameData,
  IUserGameplayData,
  UUID
} from '@nova/types';
import axios from 'axios';

import { SUPPORTED_MANUAL_TRANSLATIONS } from '../consts';

export class NovaUserRepository {
  public static async fetchUser(id: UUID, gameAPIEndpoint: string, authHeaders: INovaUserAuthHeaders): Promise<INovaUserGameData> {
    // console.log(`NovaUserRepository::fetchUser: Fetching user data for <${id}> at endpoint <${gameAPIEndpoint}> with authHeaders:`, authHeaders);
    const [details, gameData] = await Promise.all([
      NovaUserRepository.getUserDetails(gameAPIEndpoint, authHeaders),
      NovaUserRepository.getUserGameData(gameAPIEndpoint, authHeaders)
    ]);

    const userData: INovaUserGameData = {
      // * Same id on sub & super property... no point really, but understandable to keep "id" high up.
      // ? Just spread "details" into IUserDbFull with "gameData" as their sibling? Likely cleaner.
      id: id.toUpperCase() as UUID,
      minUserDetails: details,
      gameplayData: gameData
    };

    return userData;
  }

  // TODO: made some yolo attempt at fix, the setting of headers will need some refactor
  private static async getUserDetails(gameAPIEndpoint: string, authHeader: INovaUserAuthHeaders): Promise<IMinUserDetails> {
    try {
      const assetPath = `${gameAPIEndpoint}/users/details`;
      const headers: Record<string, any> = { ...authHeader };
      return await (axios.get(assetPath, { headers }).then(({ data }: any) => data) as Promise<IMinUserDetails>);
    }
    catch (e) {
      console.error('User does not have Nova account data', e);
      throw e;
    }
  }

  private static async getUserGameData(gameAPIEndpoint: string, authHeader: INovaUserAuthHeaders): Promise<IUserGameplayData> {
    try {
      const assetPath = `${gameAPIEndpoint}/user-game-data`;
      const headers: Record<string, any> = { ...authHeader };
      return await (axios.get(assetPath, { headers }).then(({ data }: any) => data) as Promise<IUserGameplayData>);
    }
    catch (e) {
      console.error('User does not have Nova game data:', e);
      throw e;
    }
  }

  /**
   * Retrieves a specified number of random nicknames for a given locale.
   *
   * @param locale - The locale for which to retrieve the random nicknames.
   * @param count - The number of random nicknames to retrieve.
   * @returns A promise that resolves to an array of random nicknames.
   * @throws If the user does not have Nova game data or an error occurs during the retrieval process.
   */
  public static async getRandomNicknames(gameAPIEndpoint: string, locale: SUPPORTED_MANUAL_TRANSLATIONS, count: number): Promise<string[]> {
    if (count < 1) {
      return [];
    }

    try {
      const path = `${gameAPIEndpoint}/users/nickname/random/${locale}?count=${count}`;
      return await (axios.get(path).then(({ data }: any) => data) as Promise<string[]>);
    }
    catch (e) {
      console.error('User does not have Nova game data:', e);
      throw e;
    }
  }
}
